import React, { useEffect } from 'react'
import {
	validateAlphaRequired,
	hasError,
	removeError,
} from '../captureAwbUtils'
import moment from 'moment'
import { Calendar } from 'primereact/calendar'
import { useTranslation } from 'react-i18next'
import MESSAGES from '../../../constants/Messages'
import CommonInput from '../../../common/Resusable/CommonInput'
import AppCalendar from '../../../common/Calendar'
const ExecutionDetails = ({ awbDetails, setAwbDetails, error, setError, isDisabled }) => {
	//for multilingual
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const englishLabelT = i18n.getFixedT('en', 'labels')

	let awbExecutionDetails = awbDetails.awbExecutionDetails

	useEffect(() => {}, [])

	const handleChangeDate = (date) => {
		awbExecutionDetails.issueDate = date
		setAwbDetails((prevState) => ({
			...prevState,
			awbExecutionDetails: awbExecutionDetails,
		}))
		if (!date) {
			setError((prevState) => ({
				...prevState,
				issuedDate: MESSAGES.ENTER_VALID_DATE,
			}))
		}
	}

	return (
		<div className='cutom-details'>
			<div className='portal-row'>
				<div className='portal-col'>
					<div className='execution-details-section mt-2 mb-md-3 mb-0'>
						<div className='shipping-deparr-row mb-2'>

							<div
								className={`form-group ${hasError(`issuedBy`, error) ? "red-border" : ""
									}`}
							>
								<CommonInput
									id='issuedBy'
									type='text'
									disabled={isDisabled}
									label={englishLabelT('CAPTURE_AWB.ISSUED_BY')}
									maxLength='35'
									value={awbExecutionDetails.issuedBy ? awbExecutionDetails.issuedBy.toUpperCase() : ''}
									onChange={(e) => {
										awbExecutionDetails.issuedBy = e.target.value
										setAwbDetails((prevState) => ({
											...prevState,
											awbExecutionDetails: awbExecutionDetails,
										}))
									}}
									onBlur={(e) => {
										validateAlphaRequired(
											e.target.value,
											setError,
											'issuedBy',
											'COMMON.ISSUED_BY'
										)
									}}
									aria-invalid={hasError('issuedBy', error)}
									onFocus={(e) => {
										removeError(e, setError)
									}}
									error={error && error['issuedBy']
										? t(error['issuedBy'], { ns: 'errors' })
										: ''}
								/>
							</div>

							<div
								className={`form-group ${hasError(`issuedPlace`, error) ? "red-border" : ""
									}`}
							>
								<CommonInput
									id='issuedPlace'
									type='text'
									disabled={isDisabled}
									label={englishLabelT('CAPTURE_AWB.ISSUED_PLC')}
									maxLength='35'
									value={awbExecutionDetails.issuedPlace ? awbExecutionDetails.issuedPlace.toUpperCase() : ''}
									onChange={(e) => {
										awbExecutionDetails.issuedPlace = e.target.value
										setAwbDetails((prevState) => ({
											...prevState,
											awbExecutionDetails: awbExecutionDetails,
										}))
									}}
									onBlur={(e) => {
										validateAlphaRequired(
											e.target.value,
											setError,
											'issuedPlace',
											'COMMON.ISSUED_PLC'
										)
									}}
									aria-invalid={hasError('issuedPlace', error)}
									onFocus={(e) => {
										removeError(e, setError)
									}}
									error={error && error['issuedPlace']
										? t(error['issuedPlace'], { ns: 'errors' })
										: ''}
								/>
							</div>

						</div>
						<div className='shipping-deparr-row mb-2'>
							<div className={`form-group calendar-group `}>
								<AppCalendar
									id='issuedDate'
									disabled={isDisabled}
									className='form-item__field'
									dateFormat='dd M yy'
									label={englishLabelT('CAPTURE_AWB.ISSUED_DATE')}
									value={
										awbExecutionDetails.issueDate
											? moment(awbExecutionDetails.issueDate, 'DD-MMM-YYYY').toDate()
											: moment().toDate()
									}
									onChangeHandler={handleChangeDate}
									placeholder='Issued date'
									showOtherMonths={false}
									minDate={moment().toDate()}
									onFocus={() => {
										setError((prevState) => ({
											...prevState,
											issuedDate: '',
										}))
									}}
									onBlur={({ target }) => { }}
									error={error && error['issuedDate']
										? t(error['issuedDate'], { ns: 'errors' })
										: ''}
								/>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ExecutionDetails
